import { createSelector } from '@reduxjs/toolkit';

import type { AppState } from '@/types';

export const selectMessages = (state: AppState) => state.messages;

export const messagesSelector = createSelector(selectMessages, ({ byId, ids }) => ids.map(id => byId[id]));
